import { render, staticRenderFns } from "./editEmail.vue?vue&type=template&id=4b728d70&"
import script from "./editEmail.vue?vue&type=script&lang=js&"
export * from "./editEmail.vue?vue&type=script&lang=js&"
import style0 from "./editEmail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports